{
  "title": "Ny salgsavtale",
  "breadcrumb": "Ny salgsavtale",
  "agreementInformation": {
    "section": {
      "title": "Om salgsavtalen",
      "description": "Fyll inn nødvendig informasjon om den nye salgsavtalen"
    },
    "date": {
      "label": "Dato for salgsavtale",
      "description": "Velg start og sluttdato for salgsavtalen",
      "placeholder": "Velg datoer"
    },
    "name": {
      "label": "Navn på salgsavtale",
      "description": "Gi avtalen et navn"
    },
    "responsibleEmployee": {
      "label": "Ansvarlig ansatt",
      "description": "Velg ansatt som har ansvaret for salgsavtalen",
      "placeholder": "Velg ansatt",
      "noResultsText": "Ingen ansatte funnet"
    },
    "issuer": {
      "label": "Utsteder av mål- og transportoppdrag",
      "description": "Velg mellom selger, kjøper eller ingen",
      "placeholder": "Velg utsteder",
      "options": {
        "none": "Ingen",
        "seller": "Selger",
        "buyer": "Kjøper"
      }
    },
    "orderNumber": {
      "label": "Varemottaker bestillingsnummer (8 siffer)",
      "description": "Eksempel: 12345678"
    },
    "commission": {
      "label": "Provisjon",
      "description": "Oppgis mellom 0-100%. Eksempel: 12,50"
    },
    "certificationType": {
      "label": "Sertifiseringstype",
      "description": "Velg hvilken type sertifisering som skal brukes",
      "placeholder": "Velg sertifiseringstype",
      "options": {
        "none": "Ikke angitt",
        "pefc": "PEFC",
        "fsc": "FSC",
        "pefcAndFsc": "PEFC / FSC",
        "other": "Annet"
      }
    },
    "certificateText": {
      "label": "Sertifikattekst på dokumenter",
      "placeholder": ""
    },
    "measurementCostsNotRefunded": {
      "label": "Målekostnader skal ikke refunderes"
    }
  },
  "step1": {
    "title": "Transportinformasjon",
    "description": "Fyll inn nødvendig informasjon om transportør"
  },
  "transportResponsible": {
    "label": "Transportansvarlig",
    "description": "Velg hvem som administrerer transport av virke",
    "noResultsText": "Ingen transportansvarlige funnet"
  },
  "transportPayer": {
    "label": "Transportbruker",
    "description": "Velg hvem som er ansvarlig for transportkostnaden",
    "noResultsText": "Ingen transportbrukere funnet"
  },
  "measurementOrganization": {
    "label": "Måleorganisasjon",
    "description": "Velg hvem som er ansvarlig for måling av virke",
    "noResultsText": "Ingen måleorganisasjoner funnet"
  },
  "deliveryLocations": {
    "label": "Mottakssteder",
    "description": "Velg ett eller flere mottakssteder",
    "noResultsText": "Ingen mottakssteder funnet"
  },
  "error": {
    "title": "Kunne ikke laste inn salgsavtaleskjemaet",
    "description": "Noe gikk galt under henting av tømmerkjøperopplysninger. Prøv igjen.",
    "retry": "Prøv igjen",
    "goToOverview": "Tilbake til oversikt"
  },
  "navigation": {
    "backToOverview": "Tilbake til oversikt",
    "cancel": "Avbryt",
    "next": "Neste",
    "save": "Lagre salgsavtalen"
  },
  "toast": {
    "error": {
      "title": "Kunne ikke opprette salgsavtale",
      "description": "Noe gikk galt under opprettelsen av salgsavtalen. Prøv igjen."
    }
  },
  "cancelDialog": {
    "title": "Vil du avbryte opprettingen av ny salgsavtale?",
    "description": "All informasjon du har fylt ut vil gå tapt og må fylles inn på nytt.",
    "confirmCancel": "Avbryt uten å lagre",
    "continueEditing": "Fortsett oppretting"
  },
  "stepper": {
    "step1": "Salgsavtaleinformasjon",
    "step2": "Hovedsortimenter"
  }
}
